"use strict";

exports.getOrganizationFromFull = function (full) {
    return full.restaurant || full.chain || full.portal || full.affiliate || full.distributor || full;
};